export enum InputDataTypeEnum {
    String = 1,
    Datetime = 2,
    Int = 3,
    Decimal = 4,
    Rating = 5,
    Dropdown = 6,
    Checkbox = 7,
}
